// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"18a97945","453":"0e79bdee","455":"461bdc8a","977":"670ceec1"}[chunkId] + ".chunk.js";
};